<template>
  <div class="product-grouped-info">
    <h3
      v-if="productInfo.brand"
      class="product-grouped-info__name"
    >
      {{ productInfo.brand }}
    </h3>

    <component
      :is="productInfo.url ? AppLink : 'p'"
      v-if="productInfo.name"
      :to="productInfo.url || undefined"
      class="product-grouped-info__description"
    >
      {{ productInfo.name.trim().replace(new RegExp(`\\s*${productInfo?.brand}\\s*$`), '') }}
    </component>

    <div
      v-if="productInfo?.sku"
      class="product-grouped-info__sku"
    >
      <span>{{ $t('Art.Number: {sku}', { sku: productInfo.sku || '' }) }}</span>
    </div>

    <div class="product-grouped-info__prices">
      <ProductPrice
        v-if="productPrices"
        class="add-to-cart__price"
        :prices="productPrices"
        :show-currency="true"
        :show-vat-tag="false"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { AppLink } from '#components'

defineProps<{
  productInfo: {
    brand?: string
    name?: string
    sku?: string
    url?: string
  }
  productPrices: {
    finalPrice?: string | number
    regularPrice: string | number
  }
}>()
</script>
